import React from "react";
import { useTranslation } from "react-i18next";
import Logo from "../Logo";
import Button from "../buttons";

export default function AboutFgfSection() {
  const { t } = useTranslation();

  return (
    <section className="about-fgf-section">
      <div className="container text-center">
        <Logo height="200px" />
        <h2 className="size-2 natural-8 text-bold">{t("about_atlas")}</h2>
        <h6 className="size-7 natural-6 lh-24 text-medium">
          {t("deadline_6_year")}
        </h6>
        <Button className="m-auto natural-3" onClick={() => {}}>
          {t("learn_more_how_work")}
        </Button>
      </div>
    </section>
  );
}
